<template>
<div id="integrationSetup">
    <div class="content">  
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <router-link :to="`/${$i18n.locale}/integrationsetup/new`"><img src="../../assets/images/add_record.png" style="height: 22px; margin-bottom: 5px;"></router-link>
                <!--a href="" style="margin-left: 20px;"><u>IMPORT</u></a-->    

                <a href="" @click.prevent="printPDF()" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left: 8px"></a>
                <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <v-data-table
                    :headers="headers"
                    :items="integrationSetups"
                    :pagination.sync="pagination"
                    class="elevation-1 fixed-header"
                >
                    <template slot="items" slot-scope="props">
                        <td class="justify-center layout px-0">
                            <v-icon
                                small
                                class="mr-2 pt-3"
                            @click="redirectTo('/' + $i18n.locale + '/integrationsetup/edit/' + props.item.id)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                small
                                class="pt-3"
                                @click="deleteIntegrationSetup(props.item, props.item.id, props.item.description)"
                            >
                                delete
                            </v-icon>
                        </td>

                        <td class="text-xs-left">{{ props.item.id }}</td>
                        <td class="text-xs-left">{{ props.item.description }}</td>
                        <td class="text-xs-left">{{ props.item.destination }}</td>
                        <td class="text-xs-left">{{ props.item.apiendpoint }}</td>
                        <td class="text-xs-left">{{ props.item.username }}</td>
                        <td class="text-xs-left">{{ props.item.apikey }}</td>
                        <td class="text-xs-left">{{ props.item.port }}</td>
                        <td class="text-xs-left">{{ props.item.cutoffdate }}</td>
                        <td class="text-xs-left">{{ props.item.remark }}</td>
                        <td class="text-xs-left">{{ Number(props.item.disable) === 1 ? 'Y' : 'N' }}</td>

                    </template>
                    <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                    </template>
                </v-data-table> 
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

export default {
    data () {
        return {
            title: 'INTEGRATION SETUP',
            headers: [
                    { text: 'ACTION', sortable: false, value: 'action' },
                    { text: 'ID', value: 'id' },
                    { text: 'DESCRIPTION', value: 'description' },
                    { text: 'DESTINATION', value: 'destination' },
                    { text: 'API ENDPOINT', value: 'apiendpoint' },
                    { text: 'USERNAME', value: 'username' },
                    { text: 'API KEY', value: 'apikey' },
                    { text: 'API PORT', value: 'port' },
                    { text: 'CUTOFF DATE', value: 'cutoffdate' },
                    { text: 'REMARK', sortable: false, value: 'remark' },
                    { text: 'DISABLE', value: 'disable' }
            ],
            status: '',
            integrationSetups: [],
            pagination: {'sortBy': 'created_at', 'descending': true, 'rowPerPage': -1},
        }
    },

    methods: {
        loadIntegrationSetups() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/integrationsetup/list')
            .then(function (response) {
                response.data.rec.forEach(function(item) {
                    item.cutoffdate = item.cutoffdate ? moment(item.cutoffdate).format('YYYY-MM-DD') : null
                })
                vm.integrationSetups = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        deleteIntegrationSetup(item, id, name) {
            var vm = this
            const index = vm.integrationSetups.indexOf(item)
            if (id === 1) {
                alert("Cannot delete " + name + ". Required by system.")
            } else {
                if(confirm('Are you sure you want to delete ' + name + '?')) {
                    axios.delete(this.$store.getters.rootAPI + '/integrationsetup/' + id)
                    .then(function (response) {
                        if (response.data.status === "error") {
                            alert("Cannot delete integration setup " + name + " because it is in used!")
                        } else {
                            vm.integrationSetups.splice(index, 1)
                        }                    
                    })
                    .catch(function (error) {
                        alert('An error occured.')
                    })
                }
            }
        },

        redirectTo(path) {
            this.$router.push(path)
        },

        checkNullVal(value) {
            if (!value) {
                return ''
            } else  {
                return value
            }
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.integrationSetups
            let data = []

            for (var i = 0; i < item.length; i++) {
                data.push({
                    ID: this.checkNullVal(item[i].id),
                    DESCRIPTION: this.checkNullVal(item[i].desc),
                    DESTINATION: this.checkNullVal(item[i].destination),
                    APIENDPOINT: this.checkNullVal(item[i].apiendpoint),
                    USERNAME: this.checkNullVal(item[i].username),
                    KEY: this.checkNullVal(item[i].key),
                    PORT: this.checkNullVal(item[i].port),
                    CUTOFFDATE: this.checkNullVal(item[i].cutoffdate),
                    REMARK: this.checkNullVal(item[i].remark)
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.integrationSetups

            var head = [                
                { title: 'ID', dataKey: 'ID' },
                { title: 'DESCRIPTION', dataKey: 'DESCRIPTION' },
                { title: 'DESTINATION', dataKey: 'DESTINATION' },
                { title: 'API ENDPOINT', dataKey: 'APIENDPOINT' },
                { title: 'USERNAME', dataKey: 'USERNAME' },
                { title: 'KEY', dataKey: 'KEY' },
                { title: 'API PORT', dataKey: 'PORT' },
                { title: 'CUTOFF DATE', dataKey: 'CUTOFFDATE' },
                { title: 'REMARK', dataKey: 'REMARK' }
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({
                        ID: this.checkNullVal(item[i].id),
                        DESCRIPTION: this.checkNullVal(item[i].desc),
                        DESTINATION: this.checkNullVal(item[i].destination),
                        APIENDPOINT: this.checkNullVal(item[i].apiendpoint),
                        USERNAME: this.checkNullVal(item[i].username),
                        KEY: this.checkNullVal(item[i].key),
                        PORT: this.checkNullVal(item[i].port),
                        CUTOFFDATE: this.checkNullVal(item[i].cutoffdate),
                        REMARK: this.checkNullVal(item[i].remark)
                    })
            }
            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },

    created() {
        this.loadIntegrationSetups()
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/integrationsetup/IntegrationSetup.vue